import React, { useContext } from 'react'
import { EXCLUDED_BRANDS } from '../utils/constants'
import { Tag } from 'chemistry'
import { TranslateContext } from 'client/common/translator'

const getLangPrefix = lang => {
  if (lang === 'fr') return '/fr'
  return lang === 'nl_BE' ? '/nl' : ''
}

export const getBrandInfo = ({ brands }, lang) => {
  if (brands && brands.length > 0 && !EXCLUDED_BRANDS.includes(brands[0].name)) {
    const brand = brands[0]
    const langPrefix = getLangPrefix(lang)
    const filterName = lang === 'fr' ? 'Marques' : 'Merken'
    const brandLink = `${langPrefix}/search?${filterName}=${encodeURIComponent(brand.name)}&filterKeys=${filterName}`
    return [brand.name, brandLink]
  }
  return []
}

const ProductSuggestions = ({ breadcrumbs, productDetails, lang }) => {
  const t = useContext(TranslateContext)
  const category = breadcrumbs.slice(-1)[0]
  const [brandName, brandLink] = getBrandInfo(productDetails, lang)
  const brandText = lang === 'fr' ? `Produits ${brandName}` : `${brandName} producten`

  if (!category && !brandName) return null

  return (
    <div className='mxd-product-detail-layout-suggestions flex flex-wrap gap-1 mt3'>
      <p className='col-12'>{t('product_related_products')}</p>
      {category && (
        <Tag as='a' href={category.path}>
          {category.categoryName}
        </Tag>
      )}
      {brandName && (
        <Tag as={'a'} href={brandLink}>
          {brandText}
        </Tag>
      )}
    </div>
  )
}

export default ProductSuggestions
